module.exports = __webpack_public_path__ + "static/media/消息提示音.fdd1fae.mp3";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/消息提示音.mp3
// module id = Ut2Y
// module chunks = 0